const level = 1;
const levelCreate = 14;
const Transaction = {
  path: "/transaction",
  name: "",
  redirect: "/transaction",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      name: "",
      component: () => import("@/views/pages/transaction"),
      meta: {
        requiresAuth: true,
        activeUrl: "/transaction",
        parent: "/transaction",
        lv: level,
      },
    },
    {
      path: "/transaction/details/:id",
      name: "Booking Detail",
      component: () => import("@/views/pages/transaction/transactiondetail"),
      meta: {
        requiresAuth: true,
        lv: level,
        isChildren: true,
        activeUrl: "/transaction",
      },
    },
    {
      path: "/transaction/create",
      name: "Create Booking",
      component: () => import("@/views/pages/transaction/createTransaction"),
      meta: {
        requiresAuth: true,
        lv: levelCreate,
        isChildren: true,
        activeUrl: "/transaction",
      },
    },
  ],
  meta: { requiresAuth: true },
};
export default Transaction;
